import { Document } from '@contentful/rich-text-types'
import classNames from 'classnames'
import { Asset } from 'contentful'
import AnimateIn from '@/atoms/AnimateIn'
import { ParagraphLG, TitleLG } from '@/atoms/Text'
import ContentfulImage from '@/molecules/ContentfulImage'
import { Content, mapContent } from '@/utils/TorchGuildUtil'
import TextBlock from './TextBlock'

interface BioProps {
  items: Content[]
}

interface Bio {
  id: string
  contentType: 'contentBlock'
  image?: Asset
  subtitle?: string
  text?: Document
  title: string
}

export const Bios = ({ items = [] }: BioProps) => {
  const bios = items.map(mapContent) as unknown as Bio[]

  return (
    <div className="flex flex-col gap-10">
      {bios.map(({ id, image, subtitle, text, title: name }) => {
        const { width = 1, height = 1 } = image?.fields.file.details.image || {}
        const isLandscape = width / height > 1

        return (
          <AnimateIn key={id} variant="slideOver" className="flex flex-col gap-x-8 gap-y-4 md:flex-row">
            {image && (
              <ContentfulImage
                image={image}
                width={130}
                height={isLandscape ? 130 : undefined} // For some reason need this if image is landscape
                focus="face"
                fit="fill"
                quality={100}
                containerClassName="self-center md:self-start mb-4 mr-5 w-[130px] h-[130px] overflow-hidden rounded-full shadow-[0px_7px_8px_#C0C0C0]"
                className={classNames('object-cover object-center', {
                  'h-full w-auto max-w-none': isLandscape,
                })}
              />
            )}

            <div className="flex flex-col gap-2 md:w-[78%]">
              <TitleLG
                as={(p) => <p {...p} />}
                color="core-gray-700"
                weight="semibold"
                className="text-center md:text-left"
              >
                {name}
              </TitleLG>
              {subtitle && (
                <ParagraphLG color="core-gray-950" className="text-center italic md:text-left">
                  {subtitle}
                </ParagraphLG>
              )}
              {text && <TextBlock document={text} />}
            </div>
          </AnimateIn>
        )
      })}
    </div>
  )
}
